import { render, staticRenderFns } from "./order-data-table.vue?vue&type=template&id=31efeaa4&"
import script from "./order-data-table.vue?vue&type=script&lang=js&"
export * from "./order-data-table.vue?vue&type=script&lang=js&"
import style0 from "./order-data-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports